export default __webpack_public_path__ + "static/media/40.3b5db447.png";